import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { GatherLeadSourceStepComponent } from "../../wizard/wizard-steps/gather-lead-source-step/gather-lead-source-step.component";
import { WizardStepBase } from "./wizard-step-base.model";
import { Option } from "../../models/wizard/option.model";
import { OptionUtils } from "../../models/wizard/option-utils";

export class GatherLeadSourceStep extends WizardStepBase {

  pickAgentReferralFromAList: boolean = true;

  leadSourceOptions: Option[] = [
    OptionUtils.create('leadSource.socialMedia',     'Social Media',       'Social Media',       'Social Media',       'Social Media'),
    OptionUtils.create('leadSource.realEstateAgent', 'Real Estate Agent',  'Real Estate Agent',  'Real Estate Agent',  'Real Estate Agent'),
    OptionUtils.create('leadSource.internet',        'Internet',           'Internet',           'Internet',           'Internet'),
    OptionUtils.create('leadSource.pastClients',     'Past Clients',       'Personal Referral',  'Personal Referral',  'Past Clients'),
    OptionUtils.create('leadSource.returningClient', 'Returning Client',   'Returning Client',   'Returning Client',   'Returning Client'),
    OptionUtils.create('leadSource.radio',           'Radio',              'Radio',              'Radio',              'Radio'),
    OptionUtils.create('leadSource.letterInTheMail', 'Letter in the Mail', 'Letter in the Mail', 'Letter in the Mail', 'Letter in the Mail'),
    OptionUtils.create('leadSource.other',           'Other',              'Other',              'Other',              'Other'),
  ];

  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = GatherLeadSourceStepComponent;
  }
}

